const SaleIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="3.8002"
        y="13.1996"
        width="24.8"
        height="13.8"
        rx="1"
        stroke="black"
        strokeWidth="1.2"
      />
      <path
        d="M22.7265 20.4832V21.3879H25.0001V22.4148H21.5615V17.5859H24.925V18.6128H22.7265V19.4564H24.806V20.4832H22.7265Z"
        fill="black"
      />
      <path d="M18.4072 17.5859V21.3879H20.6745V22.4148H17.2422V17.5859H18.4072Z" fill="black" />
      <path
        d="M16.4792 22.4148H15.2453L14.8883 21.4185H13.1471L12.79 22.4148H11.5562L13.4226 17.5859H14.6127L16.4792 22.4148ZM13.9989 19.0652L13.5354 20.3549H14.5L14.0365 19.0652H13.9989Z"
        fill="black"
      />
      <path
        d="M8.9855 22.5C8.50948 22.5 8.10027 22.3981 7.75787 22.1944C7.41547 21.9906 7.16285 21.7156 7 21.3692L7.90819 20.7763C8.14203 21.2408 8.50322 21.4731 8.99176 21.4731C9.22977 21.4731 9.41767 21.4364 9.55547 21.3631C9.69744 21.2857 9.76843 21.1817 9.76843 21.0513C9.76843 20.9617 9.74337 20.8863 9.69326 20.8252C9.64316 20.7641 9.55129 20.707 9.41767 20.654C9.28823 20.597 9.09824 20.5359 8.8477 20.4707C8.50948 20.381 8.22763 20.2914 8.00214 20.2017C7.78084 20.108 7.58458 19.9633 7.41338 19.7677C7.24219 19.5681 7.15659 19.3073 7.15659 18.9853C7.15659 18.7001 7.2401 18.4454 7.40712 18.2213C7.57832 17.9931 7.80798 17.8158 8.0961 17.6895C8.38839 17.5632 8.70991 17.5 9.06066 17.5C9.5158 17.5 9.90204 17.6019 10.2194 17.8056C10.5409 18.0053 10.7747 18.26 10.9209 18.5697L10.0503 19.1381C9.94171 18.9425 9.79974 18.7918 9.62437 18.6858C9.44899 18.5799 9.25691 18.5269 9.04813 18.5269C8.85188 18.5269 8.68486 18.5697 8.54706 18.6553C8.41344 18.7368 8.34663 18.8407 8.34663 18.967C8.34663 19.0526 8.37169 19.1239 8.42179 19.1809C8.47608 19.2339 8.56794 19.2869 8.69738 19.3399C8.82683 19.3928 9.0189 19.4519 9.27362 19.5171C9.60349 19.5986 9.88117 19.6862 10.1066 19.78C10.3321 19.8696 10.5305 20.0122 10.7017 20.2078C10.8729 20.4034 10.9585 20.6642 10.9585 20.9902C10.9585 21.2918 10.875 21.5566 10.7079 21.7848C10.5409 22.013 10.3071 22.1883 10.0064 22.3105C9.70997 22.4368 9.36965 22.5 8.9855 22.5Z"
        fill="black"
      />
      <circle cx="16.0002" cy="8.20039" r="2.2" stroke="black" strokeWidth="1.2" />
      <path
        d="M8.7998 12.9992L13.7498 8.19922M18.2498 8.19922L23.1998 12.9992"
        stroke="black"
        strokeWidth="1.2"
      />
    </svg>
  )
}

export default SaleIcon
